import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Home from './Home';

ReactDOM.render(<Home />, document.getElementById('root'));
